<template>
  <section class="hotel-attrs" v-if="getAttributesFiltered().length">
    <div class="font-m font-18 mb-12">Atuty hotelu:</div>
    <ul class="hotel-attrs__list">
      <li v-for="(item, index) in getAttributesFiltered()" :key="index">
        <span class="d-flex f-aic pb-8">
          <span class="svg-icon conv-icon" aria-hidden="true">
            <svg class="svg-icon__svg" width="22" height="22" focusable="false">
              <template v-if="item.className">
                <use
                  :xlink:href="
                    `/img/static/svg-amenities-sprites.svg#` + item.className
                  "
                ></use>
              </template>
              <template v-else>
                <use
                  xlink:href="/img/static/svg-amenities-sprites.svg#star"
                ></use>
              </template>
            </svg>
          </span>
          <span class="pr-12 text-truncate">{{ item.attributeName }}</span>
        </span>
      </li>
    </ul>
  </section>
</template>

<script>
import { xattributes } from "./xattributes.js";

export default {
  props: {
    attributes: Array,
  },
  data: () => ({
    xattr: xattributes.items,
    x: 0,
  }),
  methods: {
    getAttributesFiltered() {
      let that = this;
      return this.xattr.filter(function (value, index) {
        return that.attributes[value.id - 1] == 1;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hotel-attrs {
  margin-bottom: 24px;

  @media (min-width: $screen-sm) {
    margin-bottom: 32px;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      width: 50%;

      @media (min-width: $screen-sm) {
        width: percentage($number: 1/3);
      }
    }
  }
}

.conv-icon {
  background-color: lighten($green-default, 1%);
  border-radius: 2px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  flex-grow: 0;
  width: 26px;
  height: 26px;
  margin-right: 8px;
  padding: 3px;
}
</style>
